<template>
    <el-dialog
        class="preview-article-dialog"
        :visible.sync="visible"
        :before-close="handleClose"
        :close-on-click-modal="false"
        fullscreen
    >
        <div class="preview">
            <div class="preview-title">{{ title }}</div>
            <div class="preview-content" v-html="content" id="editor-content"></div>
        </div>
    </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { getUserArticleDetail } from "@/api/experience";

export default {
    name: 'PreviewArticle',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        id: {
            type: [Number, null],
            default: null
        }
    },
    data: () => ({
        title: '',
        content: ''
    }),
    computed: {
        ...mapState('user', ['userInfo'])
    },
    mounted() {
        if (!this.id) return;
        getUserArticleDetail({ articleId: this.id, userId: this.userInfo.id }).then(({ code, data }) => {
            if (code === 0) {
                this.title = data.title;
                this.content = data.htmlContent;
            }
        });
    },
    methods: {
        handleClose() {
            this.$emit('update:visible', false);
        }
    }
};
</script>

<style lang="scss">
.preview-article-dialog {
    .el-dialog__body {
        color: #000;
        font-size: 16px;
    }
}
</style>

<style lang="scss" scoped>
.preview-article-dialog {
    .preview {
        margin: 0 auto;
        width: 1276px;
        min-height: calc(100vh - 160px);
        &-title {
            color: #272c40;
            font-size: 22px;
            font-weight: 600;
            padding-bottom: 10px;
            border-bottom: 1px solid #ecedff;
        }
        &-content {
            padding: 20px 10px;
            overflow: auto;
        }
    }
}
</style>
